import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Permission/KeyValue', method: 'GET', body: null, token: token })
}
